// extracted by mini-css-extract-plugin
export default {"section":"KnowHow_section__MFuTZ","types":"KnowHow_types__2CpEV"};